<template>
  <div>
    <Card>
      <template slot="header">Gate Reports</template>
      <v-layout justify-center>
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="update()"
        >
          <v-text-field
            slot="activator"
            v-model="dateRange.startDate"
            label="Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="dateRange.startDate"/>
        </v-menu>
      </v-layout>
      <v-layout
        align-center
        column
      >
        <v-flex class="pa-3">
          <v-btn
            @click="loadReport('campsite')"
          >
            <v-icon left>fa-map</v-icon>Campsite
          </v-btn>
          <v-btn
            @click="loadReport('parking')"
          >
            <v-icon left>fa-car</v-icon>Parking
          </v-btn>
        </v-flex>
      </v-layout>
    </Card>
    <Campsite v-if="report =='campsite'"/>
    <Parking v-if="report =='parking'"/>
  </div>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'
import Campsite from './table/GateCampsite'
import Parking from './table/GateParking'

export default {
  components: {
    Campsite,
    Parking
  },
  data () {
    return {
      report: 'camping'
    }
  },
  computed: {
    ...mapGetters({
      dateRange: 'reports/dateRange'
    })
  },
  mounted () {
    this.getParkingAreas()
  },
  methods: {
    ...mapActions({
      updateDateRange: 'reports/updateDateRange',
      getParkingAreas: 'facilities/getParkingAreas',
      getGateCampingReport: 'reports/getGateCampingReport',
      getGateParkingReport: 'reports/getGateParkingReport'
    }),
    loadReport (report) {
      this.report = report
      let reportActions = {
        campsite: () => this.getGateCampingReport(),
        parking: () => this.getGateParkingReport()
      }
      // run the report
      reportActions[report]()
    },
    update () {
      this.updateDateRange({ startDate: this.dateRange.startDate, endDate: this.dateRange.startDate }).then(() => {
        this.loadReport(this.report)
      })
    }
  }
}
</script>

<style scoped>
  /deep/ .v-table th {
    padding: 0px !important;
  }
  /deep/ .v-table td {
    font-size: 13px !important;
    height: 13px !important;
    white-space: nowrap;
    padding: 0px !important;
    max-width: 250px;
    overflow: hidden;
  }
  /deep/ .v-table tr:nth-child(even) {
    background: rgb(240, 240, 240);
  }
</style>
